export function countryFlagEmoji(locale) {
  const MAGIC_NUMBER = 0x1f1e6 - 0x41;
  const countryCode = locale.slice(-2);
  return String.fromCodePoint(...[...countryCode].map((c) => MAGIC_NUMBER + c.charCodeAt(0)));
}
